import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { UpdatePasswordRoute } from "../../../Components/UpdatePasswordRoute";

export const Route = createFileRoute("/_authenticated/_agentLayout/update-password")({
	component: RouteComponent,
});

function RouteComponent() {
	const navigate = useNavigate();
	return (
		<UpdatePasswordRoute
			redirectAfterLogin={async () => {
				// Add a small delay to ensure login state is properly set
				await new Promise((resolve) => setTimeout(resolve, 100));
				try {
					await navigate({ to: "/stations", replace: true });
				} catch (_error) {
					// Fallback: force page reload if navigation fails
					window.location.href = "/stations";
				}
			}}
		/>
	);
}
